import "./css/Session.css";
import { isReadOnly } from "./../../lib/utils/demo";
import "react-datepicker/dist/react-datepicker.css";
import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Form } from "react-advanced-form";
import { FormCard } from "./../layout/FormCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { RIETextArea } from "@attently/riek";
import DatePicker from "react-datepicker";
import ImageUploader from "react-images-upload";
import ImageGallery from "react-image-gallery";
import Location from "./../form/Location";
import PrivacyToggle from "./../layout/PrivacyToggle";
import MainContainer from "./../layout/MainContainer";
import OwnerBadge from "./../layout/OwnerBadge";
import StarBar from "./../layout/StarBar";
import SessionRequests from "./../../requests/SessionRequests";
import { loadUserBoards } from "./../../actions/user_board";
import {
  UserSessionCleared,
  loadUserSession,
  updateUserSession,
  loadUserSessionImages,
  addUserSessionImages,
  deleteUserSessionImage,
} from "./../../actions/user_session";
import noaaForecaster from "noaa-forecasts";
import BoardPicker from "./../board/forms/BoardPicker";
import { FacebookProvider, Share, Comments, Page } from "react-facebook";
import fbConfig from "./../../config/fb";
import Conditions from "./Conditions";
import { defaultSessionTitle } from "./../../lib/utils/sessionTitle";
import { sessionPlaceholder } from "./../../lib/utils/placeholder";

const mapStateToProps = (state) => {
  return {
    session: state.session,
    current_session: state.user_sessions.selected,
    boards: state.user_boards.data,
    session_images: state.session_images,
    api: state.api,
  };
};

const withs = {
  session: ["Location", "UserBoard.UserBoardImage", "SessionData", "User"],
};

const mapDispachToProps = (dispatch) => {
  return {
    loadSession: (session, params) =>
      dispatch(loadUserSession(session, params)),
    loadBoards: (session, params) => dispatch(loadUserBoards(session, params)),
    clearSession: () => dispatch(UserSessionCleared()),
    editUserSession: (session, params) =>
      dispatch(updateUserSession(session, params)),
    loadSessionImages: (session, params) =>
      dispatch(loadUserSessionImages(session, params)),
    addImages: (session, params) =>
      dispatch(addUserSessionImages(session, params)),
    deleteSessionImage: (session, id) =>
      dispatch(deleteUserSessionImage(session, id)),
  };
};

class SessionView extends Component {
  constructor(props) {
    super(props);
    this.UserSessionRequest = new SessionRequests(props.session);

    this.state = {
      boards: [], //array of user boards to pupulate board picker
      select: { id: 0, name: "No Board Selected" }, //currently selected board
      selectedImage: null, //the id of the currently selected image, used foor delete
      selectOptions: [],
      uploaderInstance: 1, //we need to increment the uploader instance each time to clear
      imageIndex: 0, //the begining index of images
      date: "", //initialize date
      is_public: null, //internal prop to keep track of pribacy desires
      editingTitle: false, //whether the title edit input is open
      titleDraft: "", //the edit input opens blank; empty on close means cancel
    };
    this.onDrop = this.onDrop.bind(this);
  }

  /*
   * A public session opens from a shared link, so the session and its images
   * load with or without an account - the API scopes both to owner-or-public
   * and answers 404 for anything else. The board list does not load: it is the
   * picker's options, it is only reachable as your own, and a 401 anywhere
   * trips the signOut in App.js.
   */
  componentDidMount() {
    this.props.loadSession(this.props.session, {
      id: this.props.match.params.id,
      withs: withs.session,
    });
    this.props.loadSessionImages(this.props.session, {
      wheres: { session_id: this.props.match.params.id },
    });
    if (this.props.session.isLoggedIn) {
      this.props.loadBoards(this.props.session, {
        orderBy: "name_ASC",
        limit: 50,
        wheres: { user_id: this.props.session.user.id },
      });
    }
  }

  onDrop(pictureFiles, pictureDataURLs) {
    if (!pictureFiles.length) return;
    const formData = SessionRequests.createFormRequest({
      session_id: this.props.current_session.id,
      user_id: this.props.session.user.id,
    });
    pictureFiles.forEach((file, i) => {
      formData.append("photo", file);
    });
    this.props.addImages(this.props.session, { data: formData });
    this.setState({ uploaderInstance: this.state.uploaderInstance + 1 });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    //were going to use this to see if a new board was created, if so we have to add it to the availableboards and set it as selected
    ((this.props.boards.length &&
      !this.state.selectOptions.length &&
      this.props.current_session.id) ||
      prevProps.boards.length !== this.props.boards.length) &&
      this.setSelectedBoard();
  }

  setSelectedBoard = () => {
    const boardOptions = [{ id: 0, name: "select" }];
    let select = this.state.select;
    this.props.boards.map((obj) => {
      let board = { id: obj.id, name: obj.name };
      if (obj.id === this.props.current_session.board_id) select = board;
      return boardOptions.push(board);
    });
    this.setState({ selectOptions: boardOptions, select: select });
  };

  componentWillUnmount() {
    this.props.clearSession();
  }

  returnToIndex = (e) => {
    this.props.history.length > 1
      ? this.props.history.goBack()
      : this.props.history.push("/user/dashboard");
  };

  submitUpdate = (data) => {
    this.props.editUserSession(this.props.session, {
      id: this.props.match.params.id,
      data: data,
    });
    this.setState(data);
  };

  onLocationChange = (propertyName, newValue) => {
    if (!newValue) return;
    // Location reports its display name next to the id for the create form's
    // title. There is no such column here, and passing it through would fire a
    // second PUT that sequelize would then silently drop.
    if (propertyName === "location_name") return;
    const data = [];
    data[propertyName] = newValue;
    this.submitUpdate({ ...data });
  };

  onPrivacyChange = (e) => {
    // Compared against the stored record, not local state. The two used to
    // drift: the radios read their checked state from the store while the
    // guard read this.state, so after one toggle the guard would swallow the
    // next click and the control looked dead.
    const next = parseInt(e.nextValue, 10) === 1;
    if (next === this.isPublic()) return;
    this.submitUpdate({ is_public: next ? 1 : 0 });
  };

  // The API sends is_public back as a MySQL tinyint, so it arrives as 1/0 on
  // some paths and true/false on others. Strict === true missed the tinyint.
  isPublic = () => Number(this.props.current_session.is_public) === 1;

  onBoardChange = (id) => {
    if (!id) return;
    this.submitUpdate({ board_id: id });
    const idInt = parseInt(id);
    this.state.selectOptions.map((obj) => {
      if (obj.id === idInt) this.setState({ select: obj });
      return true;
    });
  };

  onImageLoad = (e) => {
    this.setState({ selectedImage: this.props.session_images[0] });
  };

  onImageSelected = (e) => {
    this.setState({
      selectedImage: this.props.session_images[e],
      imageIndex: e,
    });
  };

  deleteImage = (e) => {
    new Promise((resolve, reject) => {
      resolve(
        this.props.deleteSessionImage(
          this.props.session,
          this.state.selectedImage.id
        )
      );
    }).then((e) => {
      const newIndex =
        this.state.imageIndex === 0 ? 0 : this.state.imageIndex - 1;
      this.setState({
        imageIndex: newIndex,
        selectedImage: this.props.session_images[newIndex],
      });
    });
  };

  startTitleEdit = () => this.setState({ editingTitle: true, titleDraft: "" });

  /*
   * The input opens blank on purpose, so leaving it blank is the same gesture
   * as clicking away - it closes and the existing title stands. Getting back to
   * the generated name is the reset control, not an empty save; a blank submit
   * regenerating would have quietly destroyed a name someone typed.
   */
  commitTitle = () => {
    const next = this.state.titleDraft.trim();
    this.setState({ editingTitle: false, titleDraft: "" });
    if (!next || next === this.props.current_session.title) return;
    this.submitUpdate({ title: next });
  };

  onTitleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.target.blur();
    }
    if (e.key === "Escape") {
      // Clearing first makes the blur that follows read as a cancel.
      this.setState({ titleDraft: "" }, () => e.target.blur());
    }
  };

  resetTitle = () => {
    const session = this.props.current_session;
    const next = defaultSessionTitle(
      session.Location && session.Location.name,
      session.session_date
    );
    if (next === session.title) return;
    this.submitUpdate({ title: next });
  };

  onDateChange = (date) => {
    // UTC, not local wall clock. session_date is a zoneless DATETIME and the
    // backend floors it to a UTC hour to pick the reading, so sending 6am from
    // a UTC-7 beach as "06:00" would resolve conditions for 11pm the night
    // before - plausible numbers, wrong session.
    this.submitUpdate({ session_date: moment(date).toISOString() });
    this.setState({ date: date });
  };

  render() {
    const session = this.props.current_session;
    // DEFAULT_SESSION carries no user key, so reading .id off it threw before
    // componentDidMount could redirect - an anonymous visit rendered once and
    // hit the ErrorBoundary rather than the page.
    const viewer = this.props.session.user || {};
    // Same shared-account reason as the board view.
    const isOwner = Boolean(viewer.id) && viewer.id === session.user_id
        && !isReadOnly(this.props.session);
    // The reducer cannot know which session it is holding images for, so the
    // stand-in it supplies is generic until here.
    const galleryItems = this.props.session_images.map((image) =>
      image.placeholder
        ? Object.assign({}, image, {
            original: sessionPlaceholder(session.id),
            thumbnail: sessionPlaceholder(session.id),
          })
        : image
    );
    return (
      <MainContainer>
        <FacebookProvider appId={fbConfig.api_key}>
          <FormCard returnToIndex={this.returnToIndex}>
            <Form>
              <div className={isOwner ? "container owner" : "container"}>
                <div className="details row">
                  <div className="col-7 session-title">
                    {this.state.editingTitle ? (
                      <input
                        autoFocus
                        type="text"
                        className="gw-title-field"
                        placeholder={session.title || ""}
                        value={this.state.titleDraft}
                        onChange={(e) =>
                          this.setState({ titleDraft: e.target.value })
                        }
                        onKeyDown={this.onTitleKeyDown}
                        onBlur={this.commitTitle}
                      />
                    ) : (
                      <h1 className="gw-title-field" title={session.title || ""}>
                        {session.title}
                      </h1>
                    )}
                    <OwnerBadge user={session.User} label="Surfed by" />
                    {isOwner && !this.state.editingTitle && (
                      <div className="gw-title-actions">
                        <button
                          type="button"
                          className="gw-title-action"
                          onClick={this.startTitleEdit}
                        >
                          Edit
                        </button>
                        <button
                          type="button"
                          className="gw-title-action"
                          onClick={this.resetTitle}
                        >
                          Reset to default
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="col-5" style={{textAlign: 'right'}} >
                    <span className="gw-brand gw-brand-inline">
                      <img src="/img/glazewave_lockup.png" alt="Glazewave" />
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-7">
                    <div className="row">
                      <div className="col-6 align-middle">
                        <StarBar
                          stars={session.rating}
                          onClick={this.submitUpdate}
                          size="1x"
                          static={!isOwner}
                        />
                      </div>
                      <div className="col-6">
                        {isOwner && (
                          <div className="privacy text-right">
                            <PrivacyToggle
                              value={this.isPublic() ? "1" : "0"}
                              onChange={this.onPrivacyChange}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row preview">
                      {isOwner && (
                        <FontAwesomeIcon
                          size="lg"
                          alt="delete user"
                          style={{
                            marginLeft: ".5em",
                            float: "left",
                            cursor: "pointer",
                            position: "absolute",
                            top: "1em",
                            zIndex: "999",
                            color: "white",
                            left: "1em",
                          }}
                          icon={faTrash}
                          onClick={this.deleteImage}
                          value={this.state.imageIndex}
                        />
                      )}
                      {isOwner && (
                        <ImageUploader
                          key={this.state.uploaderInstance}
                          withIcon={false}
                          buttonText="+"
                          onChange={this.onDrop}
                          imgExtension={[
                            ".jpg",
                            ".jpeg",
                            ".gif",
                            ".png",
                            ".gif",
                          ]}
                          maxFileSize={5242880}
                          withPreview={false}
                          withLabel={false}
                          buttonClassName="upload-btn"
                          style={{
                            marginLeft: ".5em",
                            float: "left",
                            cursor: "pointer",
                            position: "absolute",
                            top: "0",
                            zIndex: "999",
                            color: "white",
                            left: "3em",
                          }}
                        />
                      )}
                      <div>
                        <ImageGallery
                          items={galleryItems}
                          showBullets={true}
                          showIndex={true}
                          startIndex={this.state.imageIndex}
                          onSlide={this.onImageSelected}
                          onImageLoad={this.onImageLoad}
                          thumbnailPosition={"bottom"}
                        />
                      </div>
                      <div className="card-body">
                        <div className="card-text">
                          <Page href={window.location.href} tabs="timeline" />
                          <Comments href={window.location.href} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="details col-5">
                    <div>
                      <div className="card">
                        <div className="detail-line">
                          <DatePicker
                            disabled={!isOwner}
                            selected={this.state.date}
                            className="date-picker-input form-control"
                            onChange={this.onDateChange} //only when value has changed
                            showTimeSelect
                            dateFormat={"MMMM d yyyy h:mm a"}
                            placeholderText={moment(
                              session.session_date
                            ).format("MMMM D YYYY h:mm a")}
                          />
                        </div>

                        <div className="detail-line">
                          <Location
                            disabled={!isOwner}
                            id="location_id"
                            name="location_id"
                            className="form-control"
                            onChange={this.onLocationChange}
                            onBlur={this.onLocationBlur}
                            value={session.location_id}
                            disable={!isOwner}
                            /*
                             * Location renders an empty input and shows the
                             * saved place through the placeholder only, so a
                             * null here is a blank box with no hint that a
                             * location was ever set. A spot picked from the
                             * nearest-spot chips has a name and a point and no
                             * address, which is why name is the fallback rather
                             * than a second null.
                             */
                            placeholder={
                              (session.Location &&
                                (session.Location.formatted_address ||
                                  session.Location.name)) ||
                              "No Location Specified"
                            }
                          />
                        </div>
                      </div>
                      {session.SessionDatum && (
                        <div className="detail-line">
                          <Conditions session={session} />
                        </div>
                      )}
                      <div className="card">
                          <BoardPicker
                            onChange={this.onBoardChange}
                            boards={this.state.selectOptions}
                            board_id={session.board_id}
                            wrapperClass="row detail-line"
                          />
                        </div>
                        <div className="card">
                        <div className="detail-line">
                          <div>
                            <strong>Notes:</strong>
                          </div>
                          <RIETextArea
                            value={
                              session.notes ||
                              "You have no notes for this session"
                            }
                            className="form-control text-area"
                            defaultValue={session.notes}
                            change={this.submitUpdate}
                            propName="notes"
                            validate={_.isString}
                            editProps={{ disabled: !isOwner }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </FormCard>
        </FacebookProvider>
      </MainContainer>
    );
  }

  loadNoaa = () => {
    var inspect = require("util").inspect;
    var obj = {
      listLatLon: "38.99,-77.01 37.7833,-122.4167",
      //product: 'time-series', // this is a default, it's not actually required
      begin: moment().format("YYYY-MM-DDTHH:mm:ss"),
      end: moment().add(3, "days").format("YYYY-MM-DDTHH:mm:ss"),
      qpf: "qpf", // first elementInputName - Liquid Precipitation Amount
      pop12: "pop12", // another elementInputName - 12 hour probability of precipitation
    };
    var token = "yPMNDtzDeHIgQPxhrkzuKJHGKlzGkSQV";
    noaaForecaster.setToken(token);
    noaaForecaster.getForecast(obj).then(function (results) {
    });
  };
}
export default connect(mapStateToProps, mapDispachToProps)(SessionView);
